
/* injects from baggage-loader */

'use strict';

/**
 * Constants to use in the lock and unlock filters module.
 */
const lockUnlockFiltersConstant = {
    CAMPAIGN: {
        LABEL: 'Campaña'
    },
    CASHIER: {
        LABEL: 'Cajero',
    },
    CHOOSE_AN_OPTION: 'Escoge una opción',
    GET_COMPONENTS_BUTTON: 'Obtener componentes',
    MULTIPLE_RESPONSIBLES: 'Solo se debe seleccionar un responsable (Cajero principal, cajero o vendedor)',
    NOT_FOUND_MESSAGE: 'No se encontraron resultados.',
    NO_SELECTED_CAMPAIGN: 'No se ha seleccionado ninguna campaña',
    NO_SELECTED_OFFICE: 'No se ha seleccionado ninguna oficina',
    OFFICE: {
        LABEL: 'Oficina'
    },
    SELLER: {
        LABEL: 'Vendedor'
    },
    STATUS: {
		LABEL: 'Estado de los componentes'
    }
}

export default lockUnlockFiltersConstant;



// WEBPACK FOOTER //
// ./src/app/core/components/lockUnlockFilters/lockUnlockFilters.constant.js